<template>
	<div class="ins-main develop-main">
		<section class="develop-area develop-slot" data-slider="slot" ref="slot">
			<div class="groupHeading develop-head develop-head-slot">
				{{this.$t('lang_men_slotDevelopment')}}
			</div>
			<div class="develop-content_bg"></div>
			<div class="slot_warrior develop-img"><img src="@img/develop/slot_warrior.png" alt=""></div>
			<div class="slot_monkey develop-img"><img src="@img/develop/slot_monkey.png" alt=""></div>
			<div class="develop-content">
				<div class="develop-content-table">
					<div class="develop-content-row">
						<div class="develop-content-cell">
							<span class="icon-03"></span><span v-html="this.$t('lang_slotDevelopmen_item1')"></span>
						</div>
						<div class="develop-content-cell">
							<span class="icon-04"></span><span v-html="this.$t('lang_slotDevelopmen_item2')"></span>
						</div>
						<div class="develop-content-cell">
							<span class="icon-05"></span><span v-html="this.$t('lang_slotDevelopmen_item3')"></span>
						</div>
					</div>
					<div class="develop-content-row">
						<div class="develop-content-cell">
							<span class="icon-06"></span><span v-html="this.$t('lang_slotDevelopmen_item4')"></span>
						</div>
						<div class="develop-content-cell">
							<span class="icon-07"></span><span v-html="this.$t('lang_slotDevelopmen_item5')"></span>
						</div>
						<div class="develop-content-cell">
							<span class="icon-08"></span><span v-html="this.$t('lang_slotDevelopmen_item6')"></span>
						</div>
					</div>
					<div class="develop-content-row">
						<div class="develop-content-cell">
							<span class="icon-09"></span><span v-html="this.$t('lang_slotDevelopmen_item7')"></span>
						</div>
						<div class="develop-content-cell">
							<span class="icon-10"></span><span v-html="this.$t('lang_slotDevelopmen_item8')"></span>
						</div>
						<div class="develop-content-cell">
							<span class="icon-11"></span><span v-html="this.$t('lang_slotDevelopmen_item9')"></span>
						</div>
					</div>
				</div>
				<div class="slot-games">
					<template v-if="isMobile">
						<carousel ref="carousel"
							:perPage="1" 
							:mouse-drag="false" 
							:navigationEnabled="false" 
							:paginationEnabled="false" 
							:loop="true"
							class="slot-games-area clearfix"
						>
							<slide>
								<div class="slot-games-cover">
									<img src="@img/develop/slot_img_1.jpg" alt="">
									<span>{{this.$t('lang_slotDevelopmen_gameName1')}}</span>
								</div>
							</slide>
							<slide>
								<div class="slot-games-cover">
									<img src="@img/develop/slot_img_2.jpg" alt="">
									<span>{{this.$t('lang_slotDevelopmen_gameName2')}}</span>
								</div>
							</slide>
							<slide>
								<div class="slot-games-cover">
									<img src="@img/develop/slot_img_3.jpg" alt="">
									<span>{{this.$t('lang_slotDevelopmen_gameName3')}}</span>
								</div>
							</slide>
							<slide>
								<div class="slot-games-cover">
									<img src="@img/develop/slot_img_4.jpg" alt="">
									<span>{{this.$t('lang_slotDevelopmen_gameName4')}}</span>
								</div>
							</slide>
						</carousel>
						<a @click.prevent="prevSlide" class="prev-btn">
							<img :src='require(`@img/develop/photoarrow.png`)'>
						</a>
						<a @click.prevent="nextSlide" class="next-btn">
							<img :src='require(`@img/develop/photoarrow.png`)'>
						</a>
					</template>
					<template v-else>
						<ul class="slot-games-area clearfix">
							<li>
								<div class="slot-games-cover">
									<img src="@img/develop/slot_img_1.jpg" alt="">
									<span>{{this.$t('lang_slotDevelopmen_gameName1')}}</span>
								</div>
							</li>
							<li>
								<div class="slot-games-cover">
									<img src="@img/develop/slot_img_2.jpg" alt="">
									<span>{{this.$t('lang_slotDevelopmen_gameName2')}}</span>
								</div>
							</li>
							<li>
								<div class="slot-games-cover">
									<img src="@img/develop/slot_img_3.jpg" alt="">
									<span>{{this.$t('lang_slotDevelopmen_gameName3')}}</span>
								</div>
							</li>
							<li>
								<div class="slot-games-cover">
									<img src="@img/develop/slot_img_4.jpg" alt="">
									<span>{{this.$t('lang_slotDevelopmen_gameName4')}}</span>
								</div>
							</li>
						</ul>
					</template>
				</div>
			</div>
		</section>
		<section class="develop-area develop-keno" data-slider="keno" ref="keno">
			<div class="groupHeading develop-head-keno develop-head">
				{{this.$t('lang_men_lotteryDevelopment')}}
			</div>
			<div class="develop-content">
				<div class="develop-content-table">
					<div class="develop-content-row">
						<div class="develop-content-cell">
							<span class="icon-12"></span><span v-html="this.$t('lang_lotteryDevelopment_item1')"></span>
						</div>
						<div class="develop-content-cell">
							<span class="icon-13"></span><span v-html="this.$t('lang_lotteryDevelopment_item2')"></span>
						</div>
						<div class="develop-content-cell">
							<span class="icon-11"></span><span v-html="this.$t('lang_lotteryDevelopment_item3')"></span>
						</div>
					</div>
					<div class="develop-content-row">
						<div class="develop-content-cell">
							<span class="icon-14"></span><span v-html="this.$t('lang_lotteryDevelopment_item4')"></span>
						</div>
						<div class="develop-content-cell">
							<span class="icon-15"></span><span v-html="this.$t('lang_lotteryDevelopment_item5')"></span>
						</div>
						<div class="develop-content-cell">
							<span class="icon-16"></span><span v-html="this.$t('lang_lotteryDevelopment_item6')"></span>
						</div>
					</div>
					<div class="develop-content-row">
						<div class="develop-content-cell">
							<span class="icon-17"></span><span v-html="this.$t('lang_lotteryDevelopment_item7')"></span>
						</div>
						<div class="develop-content-cell">
							<span class="icon-18"></span><span v-html="this.$t('lang_lotteryDevelopment_item8')"></span>
						</div>
						<div class="develop-content-cell">
							<span class="icon-09"></span><span v-html="this.$t('lang_lotteryDevelopment_item9')"></span>
						</div>
					</div>
				</div>
				<ul class="keno-games-area clearfix">
					<li><img src="@img/develop/logo_1.png" alt=""></li>
					<li><img src="@img/develop/logo_2.png" alt=""></li>
					<li><img src="@img/develop/logo_3.png" alt=""></li>
					<li><img src="@img/develop/logo_4.png" alt=""></li>
					<li><img src="@img/develop/logo_5.png" alt=""></li>
					<li><img src="@img/develop/logo_6.png" alt=""></li>
					<li><img src="@img/develop/logo_7.png" alt=""></li>
					<li><img src="@img/develop/logo_8.png" alt=""></li>
					<li><img src="@img/develop/logo_9.png" alt=""></li>
					<li><img src="@img/develop/logo_10.png" alt=""></li>
				</ul>
			</div>
			<div class="develop-content_bg"></div>
			<div class="keno_ball_all develop-img"><img src="@img/develop/keno_ball_all.png" alt=""></div>
			<div class="keno_ball_top develop-img"><img src="@img/develop/keno_ball_top.png" alt=""></div>
			<div class="keno_ball_bottom develop-img"><img src="@img/develop/keno_ball_bottom.png" alt=""></div>
			<div class="keno_snails develop-img"><img src="@img/develop/keno_snails.png" alt=""></div>
		</section>
	</div>
</template>

<script>
import $ from 'jquery'
import { Carousel, Slide } from 'vue-carousel';

export default {
	name: 'Develop',
	components: {
    Carousel,
    Slide
  },
	data() {
		return{
      typeName: 'slot',
			scrollHeight: 0,
			isMobile: false,
		}
	},
  watch:{
    '$route' (to) {
      this.typeName = to.params.name
      this.getScrollHeight()
    },
  },
  methods:{
    getScrollHeight(init){
			const speed = init === 'mounted' && this.typeName !== 'keno' ? 0 : 500;
      if(this.typeName === 'keno') {
        this.scrollHeight = this.$refs.keno.offsetTop - $('header').outerHeight()
      }else {
        this.scrollHeight = 0
      }
      $('body,html').animate({
        scrollTop: this.scrollHeight
      },speed);
		},
		getWinSize(){
			const $this = this;
			$(window).resize(function(){
				$this.isMobile = $(window).width() > 996 ? false : true
			})
			$this.isMobile = $(window).width() > 996 ? false : true
		},
		nextSlide() {
      this.$refs.carousel.goToPage(this.$refs.carousel.getNextPage());
    },
    prevSlide() {
      this.$refs.carousel.goToPage(this.$refs.carousel.getPreviousPage());
    }
  },
	mounted(){
    this.typeName = this.$route.params.name
		this.getScrollHeight('mounted')
		this.getWinSize()
		this.$store.dispatch('setLoadshow',false)
	},
	beforeDestroy(){
		this.$store.dispatch('setLoadshow',true)
	}
}

</script>
<style lang="sass">
  @import '@css/develop.sass'
</style>